import { useQuery } from "@tanstack/react-query";
import { accountService } from "../services/accountService";

export const useAccountActivityStats = (params = {}) => {
  return useQuery({
    queryKey: ["Verve-account-activity-stats", params],
    queryFn: () => accountService.getActivityStats(params),
  });
};
